import React from "react";

const Welcome = () => {
    return(
        <div className="welcome">
            <h1>WELCOME TO RONNIE TECH</h1>
            <p>
                Welcome to Ronnie Tech Phone Solution where 
                you get all kinds of Google frp bypass apk 
                from Android 4 to Androind 12 supported with 
                video and theory tutorial on my youtube account 
                and also you can subscribe to my account so that 
                you are updated on every video i drop instantly<br/>
                <span>Happy Unlocking!</span>
            </p>
        </div>
    )
}

export default Welcome;
